import type { IEditorVariable } from "@bbj-types/utils";
import type { Editor as TinyMCEEditor } from "@tinymce/tinymce-react";
import { useCallback, useRef } from "react";

import { registerManualVariableHandlers } from "../utils/manualVariableHandlers";

type TinyMCEEditorInstance = Exclude<TinyMCEEditor["editor"], undefined>;

interface IUseManualVariableHandlersOptions {
  getVariableList: () => IEditorVariable[] | undefined;
  syncEditorState: (content: string, editor: TinyMCEEditorInstance) => void;
}

export const useManualVariableHandlers = ({ getVariableList, syncEditorState }: IUseManualVariableHandlersOptions) => {
  const skipNextEditorChangeRef = useRef(false);

  const shouldSkipNextEditorChange = useCallback(() => {
    if (!skipNextEditorChangeRef.current) {
      return false;
    }
    skipNextEditorChangeRef.current = false;
    return true;
  }, []);

  const attachManualVariableHandlers = useCallback(
    (editor: TinyMCEEditorInstance) => {
      const detachHandlers = registerManualVariableHandlers({
        editor,
        getVariableList,
        syncEditorState,
        onManualConversionStart: () => {
          skipNextEditorChangeRef.current = true;
        },
      });

      return detachHandlers;
    },
    [getVariableList, syncEditorState]
  );

  return {
    shouldSkipNextEditorChange,
    attachManualVariableHandlers,
  };
};
